export type AppView = 'map' | 'reports';

interface HeaderProps {
  onRefresh: () => void;
  isLoading: boolean;
  view: AppView;
  onViewChange: (view: AppView) => void;
}

export function Header({ onRefresh, isLoading, view, onViewChange }: HeaderProps) {
  return (
    <header className="app-header">
      <div className="app-header__title">
        <h1>Texas Market Trends</h1>
        <p>Hot / cold real estate signals by county, derived from public source data.</p>
      </div>
      <nav className="app-header__nav" aria-label="View">
        <button
          type="button"
          className={`app-header__nav-btn${view === 'map' ? ' app-header__nav-btn--active' : ''}`}
          onClick={() => onViewChange('map')}
        >
          Map
        </button>
        <button
          type="button"
          className={`app-header__nav-btn${view === 'reports' ? ' app-header__nav-btn--active' : ''}`}
          onClick={() => onViewChange('reports')}
        >
          Report Builder
        </button>
      </nav>
      {view === 'map' && (
        <button type="button" onClick={onRefresh} disabled={isLoading} className="app-header__refresh">
          {isLoading ? 'Refreshing…' : 'Refresh now'}
        </button>
      )}
    </header>
  );
}
